module.exports = __webpack_public_path__ + "static/media/spinnerSmall.4777adf5.png";